import React, { useState } from "react";
import { Link } from "react-router-dom";

// scss
import "./header.scss";

// images
import tgt_logo from "../../assets/common/logo.png";

//components
import DesktopNavBar from "../../molecules/navBar/desktopNavBar/DesktopNavBar";
import { newUser } from "../../lib/user";
import Avatar from "react-avatar";

const Header = ({ mobileMenu, setMobileMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  console.log("User", newUser?.name);
  const handleSearchClick = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };
  const handleLogout = () => {
    // Logic for logging out user
    localStorage.removeItem('local_data')
    window.location.href = "/"

  };
  return (
    <div className="header border-bottom ">
      <div className="header-logo">
        <Link to="/">
          <img
            src={tgt_logo}
            alt="tgt Logo - Uploading"
            className="w-100 h-100"
          />
        </Link>
      </div>
      <div className="w-100 d-none d-lg-block h-100 ">
        <div className="w-100  h-100 d-flex justify-content-center align-items-center">
          <DesktopNavBar />
        </div>
      </div>

      <div className="mobile-nav-bar d-flex d-lg-none w-100  justify-content-end ">
        <i
          class="fa-solid fa-bars"
          onClick={() => setMobileMenu(!mobileMenu)}
        ></i>
      </div>
      {/* <div className={`search-bar ${isSearchOpen ? "open" : ""}`}>
        <div className="search-icon" onClick={handleSearchClick}>
          {isSearchOpen ? (
            <i class="fa fa-times" aria-hidden="true"></i> 
          ) : null}
        </div>
        {isSearchOpen && (
          <input type="text" placeholder="Search..." className="search-input" />
        )}
        <div className="search-icon" onClick={handleSearchClick}>
          {isSearchOpen ? null : (
            <span>&#128269;</span> 
          )}
        </div>
      </div> */}
      {newUser?.name ? (
        <div className="profile">
          <span><Avatar name={newUser?.name} size={50} round="50%" /></span>
          {/* <span onClick={toggleDrawer}>{newUser?.name}</span> */}
          <div className={`drawer `}>
            {newUser?.name && (
              <>
                <div className="drawer-option">{newUser.name}</div>
                <div className="drawer-option">
                  <Link to="/">Profile</Link>
                </div>
                <div className="drawer-option">
                  <Link to="/chat">Chat</Link>
                </div>
                <div className="drawer-option">
                  <button onClick={handleLogout} className="btn btn-primary">Logout</button>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="header-btn">
          <Link to="/signin">
            <button>Sign in</button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Header;
